const downloadCsvFromUrl = async (url: string, filename = "download.csv") => {
  try {
    const response = await fetch(url, {
      headers: {
        "Content-Type": "text/csv",
      },
    });

    const contentType = response.headers.get("Content-Type") || "";
    if (!response.ok || !contentType?.includes("text/csv")) {
      throw new Error(`Could not download the file. Code: ${response.status}`);
    }

    const blob = await response.blob();

    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  } catch (error) {
    console.error("An error occurred while downloading the file:", error);
    alert(
      "There was an error trying to download the file. Please try again later.",
    );
  }
};

export default downloadCsvFromUrl;
